// extracted by mini-css-extract-plugin
export default {"taskInformation":"TaskInformation_taskInformation__HzsPH","taskInformation_withBoardsLevels":"TaskInformation_taskInformation_withBoardsLevels__y4sms"};